'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _isString2 = require('lodash/isString');

var _isString3 = _interopRequireDefault(_isString2);

exports.default = PaperMenuItem;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _layout = require('../../layout');

var _icon = require('../../icon');

var _icon2 = _interopRequireDefault(_icon);

var _paperMenuItem = require('./paper-menu-item.css');

var _paperMenuItem2 = _interopRequireDefault(_paperMenuItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_HEIGHT = 52;

/**
 * Generic item container for use in paper menus
 */

function PaperMenuItem(props) {
  var _cx;

  var icon = props.icon,
      children = props.children,
      active = props.active,
      disabled = props.disabled,
      highlighted = props.highlighted,
      name = props.name,
      success = props.success,
      className = props.className,
      onClick = props.onClick,
      _props$component = props.component,
      component = _props$component === undefined ? _layout.Box : _props$component,
      minWidth = props.minWidth,
      iconAfter = props.iconAfter,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['icon', 'children', 'active', 'disabled', 'highlighted', 'name', 'success', 'className', 'onClick', 'component', 'minWidth', 'iconAfter']);


  var _classNames = (0, _classnames2.default)((_cx = {}, (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.root, true), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.highlighted, highlighted), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.active, active), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.success, success), (0, _defineProperty3.default)(_cx, _paperMenuItem2.default.disabled, disabled), _cx), className);

  return React.createElement(
    _layout.Box,
    (0, _extends3.default)({
      className: _classNames,
      flexDirection: 'row',
      minHeight: DEFAULT_HEIGHT,
      minWidth: minWidth ? minWidth : 'auto',
      alignItems: 'center',
      alignContent: 'center',
      onClick: onClick,
      name: name,
      component: component
    }, otherProps),
    icon ? React.createElement(
      _layout.Box,
      { marginRight: 10 },
      (0, _isString3.default)(icon) ? React.createElement(
        _icon2.default,
        { size: 16 },
        String(icon)
      ) : icon
    ) : null,
    React.createElement(
      _layout.Box,
      { flexDirection: 'row', className: _paperMenuItem2.default.content },
      children
    ),
    iconAfter ? React.createElement(
      _layout.Box,
      { marginLeft: 10 },
      (0, _isString3.default)(iconAfter) ? React.createElement(
        _icon2.default,
        { size: 16 },
        String(iconAfter)
      ) : iconAfter
    ) : null
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/paper-menu/components/paper-menu-item.js
// module id = 342
// module chunks = 114276838955818